import type { Theme } from '../../types/theme';

export const cursorTheme: Theme = {
  id: 'cursor',
  name: 'Cursor',
  description: 'Warm cream canvas with Cursor Orange CTA, magazine-editorial typography',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/cursor/DESIGN.md',
  visualKeywords: ['warm cream', 'editorial', 'orange CTA', 'CursorGothic', 'IDE-first'],
  colors: {
    background: '#f7f7f4',
    surface: '#ffffff',
    surfaceElevated: '#ffffff',
    textPrimary: '#26251e',
    textSecondary: '#5a5852',
    textMuted: '#5a5852',
    border: '#e6e5e0',
    borderSubtle: '#dcdbd6',
    primary: '#f54e00',
    primaryHover: '#e13a00',
    primaryActive: '#d73000',
    accent: '#f54e00',
    onPrimary: '#ffffff',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'medium',
    tone: 'warm',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
